import {bindable, bindingMode} from 'aurelia-framework';

export class PopupMenu {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) maxWidth;

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) visible = false;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) triggerElement = null;

  get style() {
    return this.maxWidth ? `max-width: ${this.maxWidth};` : '';
  }

}
